<template>
  <div class="disruption-detail-panel">
    <div v-if="loading" class="text-center py-2">
      <LoaderPic />Loading...
    </div>
    <template v-else-if="disruptions !== null">
      <div class="disruption-section-title mt-2">Ongoing</div>
      <template v-if="ongoingDisruptions.length">
        <div
          v-for="(d, idx) in ongoingDisruptions"
          :key="`ongoing-${idx}`"
          class="disruption-detail-item"
          :class="{ 'mt-1': idx > 0 }"
        >
          <div v-if="d.summary" class="disruption-summary">{{ d.summary }}</div>
          <div class="disruption-meta">
            <span v-if="d.start"><strong>From:</strong> {{ formatDate(d.start) }}</span>
            <span v-if="d.end" class="ml-3"><strong>To:</strong> {{ formatDate(d.end) }}</span>
            <span v-if="d.services && d.services.length" class="ml-3">
              <strong>Services:</strong> {{ d.services.join(', ') }}
            </span>
            <span v-if="d.psu_types && d.psu_types.length" class="ml-3">
              <strong>PSU:</strong> {{ d.psu_types.join(', ') }}
            </span>
          </div>
        </div>
      </template>
      <div v-else class="disruption-empty">No reports</div>

      <div class="disruption-section-title mt-3">Planned</div>
      <template v-if="plannedDisruptions.length">
        <div
          v-for="(d, idx) in plannedDisruptions"
          :key="`planned-${idx}`"
          class="disruption-detail-item"
          :class="{ 'mt-1': idx > 0 }"
        >
          <div v-if="d.summary" class="disruption-summary">{{ d.summary }}</div>
          <div class="disruption-meta">
            <span v-if="d.start"><strong>From:</strong> {{ formatDate(d.start) }}</span>
            <span v-if="d.end" class="ml-3"><strong>To:</strong> {{ formatDate(d.end) }}</span>
            <span v-if="d.services && d.services.length" class="ml-3">
              <strong>Services:</strong> {{ d.services.join(', ') }}
            </span>
            <span v-if="d.psu_types && d.psu_types.length" class="ml-3">
              <strong>PSU:</strong> {{ d.psu_types.join(', ') }}
            </span>
          </div>
        </div>
      </template>
      <div v-else class="disruption-empty">No reports</div>

      <div class="disruption-section-title mt-3">Historic</div>
      <template v-if="historicDisruptions.length">
        <div
          v-for="(d, idx) in historicDisruptions"
          :key="`historic-${idx}`"
          class="disruption-detail-item"
          :class="{ 'mt-1': idx > 0 }"
        >
          <div v-if="d.summary" class="disruption-summary">{{ d.summary }}</div>
          <div class="disruption-meta">
            <span v-if="d.start"><strong>From:</strong> {{ formatDate(d.start) }}</span>
            <span v-if="d.end" class="ml-3"><strong>To:</strong> {{ formatDate(d.end) }}</span>
            <span v-if="d.services && d.services.length" class="ml-3">
              <strong>Services:</strong> {{ d.services.join(', ') }}
            </span>
            <span v-if="d.psu_types && d.psu_types.length" class="ml-3">
              <strong>Usage:</strong> {{ d.psu_types.join(', ') }}
            </span>
          </div>
        </div>
      </template>
      <div v-else class="disruption-empty">No reports in last 60 days</div>
    </template>
  </div>
</template>

<script>
import LoaderPic from './elements/Loader/LoaderPic.vue'
import { formatDate } from '../utils.js'

export default {
  name: 'RecentDisruptions',
  components: { LoaderPic },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    disruptions: {
      type: Array,
      default: null
    }
  },
  methods: { formatDate },
  computed: {
    ongoingDisruptions() {
      if (!this.disruptions) return []
      const nowUtc = Date.now()
      return this.disruptions.filter(d => {
        const start = new Date(d.start).getTime()
        const end = new Date(d.end).getTime()
        return nowUtc >= start && nowUtc <= end
      })
    },
    plannedDisruptions() {
      if (!this.disruptions) return []
      const nowUtc = Date.now()
      return this.disruptions.filter(d => nowUtc < new Date(d.start).getTime())
    },
    historicDisruptions() {
      if (!this.disruptions) return []
      const nowUtc = Date.now()
      return this.disruptions.filter(d => {
        const end = new Date(d.end).getTime()
        return nowUtc > end
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.disruption-detail-panel {
  background-color: #f8f9fa;
  border-left: 3px solid #dee2e6;
  padding: 0.75rem 1rem;
  margin-bottom: 0.25rem;
  font-size: 0.875rem;
}

.disruption-section-title {
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #495057;
  margin-bottom: 0.4rem;
}

.disruption-detail-item {
  padding-bottom: 0.4rem;

  & + & {
    border-top: 1px solid #dee2e6;
    padding-top: 0.4rem;
  }
}

.disruption-summary {
  margin-bottom: 0.2rem;
  color: #343a40;
}

.disruption-meta {
  color: #6c757d;
  font-size: 0.8rem;
}

.disruption-empty {
  color: #6c757d;
  font-style: italic;
  font-size: 0.85rem;
}
</style>
